// Keep shortcut keys is this file to avoid collisions
// Either Ctrl or Cmd must be pressed for these shortcuts to work
// Avoid: C, F?, N, Q, R, T, V, W, A, X

export const SEARCH_SHORTCUT_KEY = 'K';
export const ADD_TEAM_SHORTCUT_KEY = 'P';
